import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import PageNotFound from "../pages/PageNotFound";

const Guard = (props) => {
  const loginUser = useSelector((state) => state.auth.loginUser);
  const location = useLocation();
  const forceReset = localStorage.getItem("forceReset") === "1";

  // izin verilen roller
  const permissions = ["admin", "superAdmin"];

  // force reset kontrolü (Pavza2022* kullananlar)

  if (forceReset && location.pathname !== "/reset-password") {
    return <Navigate to="/reset-password" replace />;
  }

  // loginUser yoksa veya boşsa erişim yok

  if (!loginUser) {
    return <Navigate to="/auth" replace />;
  }

  // Eğer route “herkese açık” değilse, userType izinli mi?

  if (!props.permissions?.includes("anyallow")) {
    if (!permissions.includes(loginUser.userType)) {
      return <PageNotFound />;
    }
  }

  // Aksi halde sayfa görüntülensin
  
  return <>{props.children}</>;
};

export default Guard;
